import { useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import {
  getProductPdfDownload,
  getProductPdfPrint,
} from 'b2b-apps/shop/product/redux/productPdf/selectors';

type UseProductPdfDataReturnType = {
  printPdf: RemoteRecord<any>;
  downloadPdf: RemoteRecord<any>;
};

const useProductPdfData = (): UseProductPdfDataReturnType => ({
  printPdf: useSelector(getProductPdfPrint),
  downloadPdf: useSelector(getProductPdfDownload),
});

export type { UseProductPdfDataReturnType };
export { useProductPdfData };
